import { NextPageContext } from 'next';
import InsightWrapper from './insights.style';
import { LAWTALK_INSIGHT } from '@shared/values';
import InsightPicks from '@component/InsightPicks';
import InsightList from '@component/InsightList';
import InsightService from '@service/insightService';
import PickType from '../../types/pick';
import InsightsListType from '../../types/insights';
import HttpCommon from '@utils/http-common';
import QuestionAction from '@component/QuestionAction';
import HeadMetaTag from '@component/HeadMetaTags';
import { MainLayout } from '@component/LayoutContainer';

type InsightsType = {
  isMobile: boolean;
  picks?: PickType[];
  insightsTotalCount?: number;
  insights?: InsightsListType[];
  currentPage?: string;
};
const Insights = ({
  isMobile = false,
  picks = [],
  insightsTotalCount = 0,
  insights = [],
  currentPage = '1',
}: InsightsType) => {
  return (
    <MainLayout>
      <InsightWrapper className="page-layout">
        <HeadMetaTag />
        <h1 className="page-title mobile">{LAWTALK_INSIGHT}</h1>
        <div className="insight--header-wrp desktop">
          <div className="insight--header">
            <p className="insight--title">
              로톡이 전하는 노하우,
              <span>로톡 인사이트</span>
            </p>
            <p className="insight--description">
              변호사 마케팅 인사이트부터 로톡 활용방법까지, 변호사님께 도움이 될 콘텐츠를 놓치지 마세요.
            </p>
          </div>
        </div>
        <div className="insight--picks-wrap">
          <InsightPicks isMobile={isMobile} picks={picks} />
        </div>
        {insightsTotalCount > 0 && (
          <div className="insight--list-wrap">
            <InsightList
              insightsTotalCount={insightsTotalCount}
              insights={insights}
              isMobile={isMobile}
              currentPage={currentPage}
            />
          </div>
        )}
        <QuestionAction />
      </InsightWrapper>
    </MainLayout>
  );
};

Insights.getInitialProps = async ({ query }: NextPageContext) => {
  if (!HttpCommon.isAvailableUrl()) {
    return;
  }

  const currentPage = query.page?.toString() || '1';
  let picks;
  let insights;
  let insightsTotalCount;
  try {
    const pageCount = 9;
    const res = await InsightService.getPicks();
    const picks = res?.data.map((pick: any) => {
      pick.tags = pick.tags ? pick.tags.split(', ') : [];
      pick.plainContents = String(pick.contents).replace(/<[^>]+>|&[\w]+;/gm, '');
      return pick;
    });

    const listRes = await InsightService.getList(pageCount, currentPage);
    insights = listRes?.data?.result.map((insight: any) => {
      insight.tags = insight.tags ? insight.tags.split(', ') : [];
      return insight;
    });
    insightsTotalCount = listRes.data.totalCount || 0;
    return { picks, insights, insightsTotalCount, currentPage };
  } catch (error) {
    console.error('insight getInitialProps error :>> ', error);
    return { picks, insights, insightsTotalCount, currentPage };
  }
};

export default Insights;
